export const ShopFormulaRecsDisabledPage = () => {
  return (
    <div className="min-h-screen items-center flex justify-center">
      <div className="max-w-72 text-center">
        {
          'Your organization has disabled the Shop page. Please consult with your provider about the foods or supplements that are recommended.'
        }
      </div>
    </div>
  );
};
